import { API_CALL_ERROR } from './../../store/action';
import { ApiService } from './../../api/api.service';
import { AppInjector } from './../../app-injector';
import { fork, put, takeEvery } from 'redux-saga/effects';
import * as _ from 'lodash';
import listSaga from './list/list.saga';
import detailSaga from './detail/detail.saga';
import batchSaga from './batch/batch.saga';
import storageSaga from './storage/storage.saga';
import scanRackSaga from './scan-rack/scan-rack.saga';
import eventSaga from './event/event.saga';
import { FETCH_LIST_INVENTORIES_REQUESTED, FETCH_LIST_INVENTORIES_SUCCEEDED, MOVING_PRODUCT_LOCATION_REQUEST } from './inventory.actions';
import { SCAN_RACK_COMP } from './scan-rack/edit/edit.const';
import { MAP_CURRENT_LOCATION_TO_PRODUCT, SCAN_RACK_MOVING_PRODUCT_LOCATION, SEARCH_PRODUCT_LOCATION_REQUESTED, FETCH_PRODUCTS_LOCATION_REQUESTED } from './scan-rack/edit/edit.actions';

function* getListInventories(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.inventory.list().toPromise();
    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case SCAN_RACK_COMP:
          yield put({ type: MAP_CURRENT_LOCATION_TO_PRODUCT, inventories: results, completedTracks: action.data });
          break;

        default:
          break;
      }
    } else {
      yield put({ type: FETCH_LIST_INVENTORIES_SUCCEEDED, data: results });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchListInventoriesRequest() {
  yield takeEvery(FETCH_LIST_INVENTORIES_REQUESTED, getListInventories);
}

function* movingProduct(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.event.create(action.data).toPromise();
    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case SCAN_RACK_COMP:
          yield put({ type: SCAN_RACK_MOVING_PRODUCT_LOCATION, data: result });
          yield put({
            type: SEARCH_PRODUCT_LOCATION_REQUESTED,
            data: {
              track_id: action.data.track_id,
              sku: action.data.product_sku
            }
          });
          yield put({
            type: FETCH_PRODUCTS_LOCATION_REQUESTED,
            track_id: action.data.track_id,
            data: { constraints: { location_id: action.data.location_id } },
          });
          break;

        default:
          break;
      }
    } else {
    }
  } catch (e) {}
}

function* watchMovingProductLocationRequest() {
  yield takeEvery(MOVING_PRODUCT_LOCATION_REQUEST, movingProduct);
}

export default _.map(
  [...listSaga, ...detailSaga, ...batchSaga, ...storageSaga, ...scanRackSaga, ...eventSaga, watchFetchListInventoriesRequest, watchMovingProductLocationRequest],
  item => fork(item)
);
